import { configureStore } from "@reduxjs/toolkit";

import AuthReducer from "./reducer/AuthSlice";
import counterReducer from "./reducer/CounterSlice";
import SubscriptionReducer from "./reducer/SubscriptionSlice";
import TenantnReducer from "./reducer/TenantSlice";
import UploadReducer from "./reducer/UploadSlice";
import PodcastCategoryReducer from "./reducer/PodcastCategorySlice";
import CelebrityCategoryReducer from "./reducer/CelebrityCategorySlice";
import HomeCategoryReducer from "./reducer/homeCategorySlice";
import ManagePodcastReducer from "./reducer/ManagePodcastSlice";
import AdvertisementReducer from "./reducer/AdvertisementSlice";
import cmsManagementReducer from "./reducer/cmsManagementSlice";
import NotificationReducer from "./reducer/NotificationSlice";
import dashboardReducer from "./reducer/dashboardSlice";
import LogsReducer from "./reducer/LogsSlice";
import AuthorReducer from "./reducer/authorSlice";

export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    subscription: SubscriptionReducer,
    counter: counterReducer,
    tenant: TenantnReducer,
    upload: UploadReducer,
    podcastCategory: PodcastCategoryReducer,
    celebrityCategory: CelebrityCategoryReducer,
    homeCategory: HomeCategoryReducer,
    managePodcast: ManagePodcastReducer,
    advertisement: AdvertisementReducer,
    cmsManagement: cmsManagementReducer,
    notification: NotificationReducer,
    dashboard: dashboardReducer,
    userLogs: LogsReducer,
    author: AuthorReducer,
  },
});

export default store;
